module.exports = __webpack_public_path__ + "img/t2-c18.685b920b.png";